import { AsYouType } from 'libphonenumber-js';

// ############################ Imported from Old UI ###########################

export function isPhoneValid(phone: string) {
  if (!phone || phone.length !== 10) {
    return false;
  }
  return true;
}

const usPhone = new AsYouType('US');

export function formatPhone(phone: string) {
  if (!phone || typeof phone !== 'string') return phone;

  const clean = phone
    .replace(/^1/, '')
    .replace(/[^\d]+/gi, '')
    .substr(0, 10);
  const r = usPhone.input(clean);
  usPhone.reset();
  return r;
}

export function customFormatPhone(phone: string) {
  if (!phone || typeof phone !== 'string') return phone;

  const cleanVal = phone.replace(/^\+?1/, '').replace(/[^0-9\\.]+/g, '');
  const len = cleanVal.length;
  const part1 = cleanVal.slice(0, 3);
  const part2 = cleanVal.slice(3, 6);
  const part3 = cleanVal.slice(6, 10);

  if (len === 0) return ``;
  if (len <= 6) return `(${part1}) ${part2}`;
  if (len > 6) return `(${part1}) ${part2}-${part3}`;
}
